import { useIsMobileSize } from '@/hooks';
import { useSelector } from '@/redux/helper';
import { selectHasGuidedExperienceFeature } from '@/redux/selectors/users';

import MobileWarningModal from './ui/MobileWarningModal';

/**
 * "Use a desktop" gate for guided-experience users on mobile. Deliberately NOT a tour step:
 * it applies to eligible users regardless of whether any tour is running, so it cannot be
 * driven by a step's ui config. Mounted globally, outside the Router.
 */
const TourMobileGate = () => {
  const isMobile = useIsMobileSize();
  const isLoggedIn = useSelector((state) => state.user.logged);
  const hasGuidedExperience = useSelector(selectHasGuidedExperienceFeature);

  if (!isLoggedIn || !hasGuidedExperience || !isMobile) return null;

  return <MobileWarningModal />;
};

export default TourMobileGate;
